/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const defaultApplicationData = {
  name: undefined,
  owner: undefined,
  contactPerson: undefined,
  description: undefined,
};
